import styled from 'styled-components';
import { breakpoints } from '@awaze/design-system.utils.react';
export const Spacer = styled.div `
  margin-bottom: 24px;
  @media (min-width: ${breakpoints[0]}) {
    margin-bottom: 0;
  }
`;
export const NoResultsContainer = styled.div `
  width: 100%;
`;
export const CentreAlign = styled.div `
  text-align: center;
`;
//# sourceMappingURL=no-results.styles.js.map